export const SIDE_MENU_PADDING = 'px-5 py-4'
